import angular from 'angular';
import standardizeBathroomCounts from 'common/helpers/standardize-bathroom-count';

// Convert bathroom count into more standard representation
// e.g. 2.3 baths (2 full, 3 half) -> 3.5 baths
module.exports = angular.module('common.filters.bathroom-count', [])
.filter('bathroomCount', function() {
  return standardizeBathroomCounts;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/bathroom-count.js
 **/